declare global {
  interface Window {
    AdyenCheckout?: (_: unknown) => Promise<{
      create: (type: string) => { mount: (_: unknown) => {} };
      createFromAction: (
        _1: unknown,
        _2?: unknown
      ) => { mount: (_: unknown) => {} };
    }>;
    AppleID?: AppleLogin;
    ApplePaySession: { canMakePayments: () => unknown };
    AwsWafIntegration: {
      getToken: () => Promise<void>;
      hasToken: () => boolean;
    };
    FB?: {
      XFBML: {
        parse: () => void;
      };
      init: (_: unknown) => void;
    };
    __igEmbedLoaded?: () => void;
    _wct: {
      google_tracking_id: string;
      uid: string;
    };
    awsWafCookieDomainList: string[];
    braze?: {
      changeUser: Function;
      disableSDK: Function;
      enableSDK: Function;
      getFeatureFlag: (x: string) => { enabled: boolean } | undefined;
      initialize: Function;
      logCustomEvent: Function;
      logPurchase: Function;
      openSession: Function;
    };
    env: Env;
    fbAsyncInit?: () => void;
    fbq: Function;
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
    ttq: {
      track: Function;
    };
    twq: Function;
  }
}

type AppleLogin = {
  auth: {
    signIn: () => Promise<{ authorization: { id_token: string } }>;
  };
};

export type Env = {
  ADYEN_ENV: string;
  ADYEN_KEY: string;
  ALGOLIA_API_KEY: string;
  ALGOLIA_APP_ID: string;
  ALGOLIA_LEGACY_INDEX: string;
  ALGOLIA_PRODUCTS_INDEX: string;
  APPLE_CLIENT_ID: string;
  APPLE_STORE_URL: string;
  APP_NUM_OF_RATINGS: string;
  APP_RATING: string;
  APP_RATINGS_LAST_UPDATED: string;
  BRAZE_API_KEY: string;
  BRAZE_BASE_URL: string;
  COOKIES_DOMAIN: string;
  FACEBOOK_APP_ID: string;
  FACEBOOK_PIXEL_ID: string;
  FACEBOOK_PIXEL_TOKEN: string;
  FF_ALL_AVAILABLE_SIZES: boolean;
  FF_COOKIE_PRO_SCRIPT: boolean;
  FF_GOOGLE_PAYMENT: boolean;
  FF_KLARNA_PAYMENT: boolean;
  FF_NOTIFICATION_COUNT: boolean;
  FF_NOTIFICATION_ICON_HEADER: boolean;
  FF_POPULAR_CAROUSEL: boolean;
  FF_PROMOTIONAL_BANNER: boolean;
  FF_SIGNUP_PROFILE_BUTTON: boolean;
  FF_WEB_PUSH: boolean;
  GA_TRACKING_ID: string;
  GOOGLE_LOGIN_CLIENT_ID: string;
  GTM: string;
  GTM_AUTH: string;
  GTM_PREVIEW: string;
  IS_PRODUCTION: boolean;
  SENTRY_DSN: string;
  SITE_BASE_URL: string;
};

export enum PAGE_POSITIONS {
  banner = 'Banner',
  body = 'Body',
  desktopSidebar = 'Desktop Sidebar',
  dpb = 'Dynamic Product Block',
  header = 'Header',
  image = 'Image',
  mobileSidebar = 'Mobile Sidebar',
  modal = 'Modal',
  moreColours = 'More Colours',
  productCard = 'Product Card',
  sellerSelection = 'Seller Selection',
  signInModal = 'Sign in modal',
  stickyCta = 'Sticky CTA',
  topBar = 'Top Bar',
  wtb = 'WTB'
}

export const REGISTRATION_INTERNAL_SOURCES: Record<string, string> = {
  default: '-',
  like: 'Wishlist',
  restock: 'Notify Me Modal'
};

export type PageType =
  | 'plp'
  | 'pdp'
  | 'sole-market'
  | 'contact'
  | 'sole-market-listing-selection'
  | 'sole-market-payment'
  | 'profile-notifications'
  | 'sole-market-pdp'
  | 'single-affiliate-pdp'
  | 'news-article'
  | 'unknown';

export type Icon = {
  height: string;
  width: string;
};

type Child = JSX.Element | string;
export type Children = Child | Child[];

export type FetcherData = {
  data: { action: string };
  email?: string;
  errors?: {
    authentication: boolean;
    conflict: boolean;
    email: boolean;
    message: string;
    mismatch: boolean;
    notFound: boolean;
    password: boolean;
  };
  success?: boolean;
};
